/*
 * Copyright (c) Nexign, JSC, 2025.
 */
/**
 * DChatModal component
 *
 * @author Nikolay Sviridov
 * @version 1.38.0
 * @since 1.38.0
 */


import { pageApi } from '@/main/api/page.api';
import { TDChatTokenResponse } from '@modules/dchat/types';

import { API_DCHAT_TOKEN } from '../app/Api';

const dchatApi = pageApi.injectEndpoints({
    endpoints: builder => ({
        getDChatToken: builder.query<TDChatTokenResponse, void>({
            query: () => API_DCHAT_TOKEN,
        }),
    }),
});

export const { useGetDChatTokenQuery } = dchatApi;
